export default __webpack_public_path__ + "c38f7cd729eb94c8aa8fde7df7be1ba4.png";